<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('nav.album') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.album') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<vue-masonry-wall :items="items" :options="{ width: 300, padding: 12 }">
			      <template v-slot:default="{ item }">
			        <div class="item">
			          <img :src="STATIC_URL + item.path + '/' + item.img"/>

			          <div class="Content">
			            <h5 class="text-ellipsis-1l">{{ item.title }}</h5>
			            <p class="text-ellipsis-2l">{{ item.content }}</p>
			          </div>
			        </div>
			      </template>
			    </vue-masonry-wall>
			</div>
		</div>
	</div>
</template>
<style scoped>
  .Item {
    overflow: hidden;
    border-radius: 4px;
    width: 100%;
    background: #F5F5F5;
  }
  .Content {
    padding: 20px;
    background: #F5F5F5;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
  }
  .text-ellipsis-1l {
  	  overflow: hidden;
	  display: -webkit-box;
	  text-overflow: ellipsis;
	  word-break: break-word;

	  /* autoprefixer: off */
	  -webkit-box-orient: vertical;
	  -webkit-line-clamp: 1;
	  font-family: Roboto,sans-serif;
	  font-size: 18px;
  }

  .text-ellipsis-2l {
  	  overflow: hidden;
	  display: -webkit-box;
	  text-overflow: ellipsis;
	  word-break: break-word;

	  /* autoprefixer: off */
	  -webkit-box-orient: vertical;
	  -webkit-line-clamp: 2;
	  font-family: Roboto,sans-serif;
  }
</style>
<script>
// @ is an alias to /src
import VueMasonryWall from 'vue-masonry-wall'

export default {
  name: 'AlbumList',
  components: {
    VueMasonryWall
  },
  data: function() {
	return {
	  items: []
	}
  },
  watch: {
  	
  },
  methods: {
    loadData: function() {
      let that = this,
          query = '?userId=' + localStorage.getItem('token')

	  this.$http.get(this.API3_PREFIX + 'album' + query).then(function (response) {
		that.items = response.data
      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>